<template>
  <div
    class="odf-layout"
    :class="'odf-layout--theme-' + theme"
  >
    <div class="odf-layout__background">
      <div
        class="odf-layout__background-pattern"
        :class="pattern"
      />
      <div
        class="odf-layout__background-blason"
        :class="blason"
      />
    </div>

    <div class="odf-layout__content">
      <div class="odf-layout__head">
        <div
          :is="link ? 'router-link' : 'div'"
          class="odf-layout__title"
          :to="link"
        >
          <h1>{{ title }}</h1>
        </div>

        <slot name="header" />
      </div>

      <div class="odf-layout__custom-content">
        <slot />
      </div>

      <div class="odf-layout__footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: null },
    link: { type: String, default: null },
    theme: { type: String, default: null },
    blason: { type: String, default: null },
    pattern: { type: String, default: null },
  },
};
</script>

<style lang="stylus">
.odf-layout {
  position: relative;

  height: 100%;
  padding: 30px 20px;
  +above('l') { padding: 40px 80px; }
  +above('xxl') { padding: 40px 170px; }
}

.odf-layout__background {
  overflow: hidden;
  position: absolute;
  z-index: 0;
  top:   0;
  left:  0;
  right: 0;

  width:  100%;
  height: 100%;

  .odf-layout--theme-green  & { background-color: $cl-green;  }
  .odf-layout--theme-purple & { background-color: $cl-purple; }
  .odf-layout--theme-orange & { background-color: $cl-orange; }
}

.odf-layout__background {
  & .odf-layout__background-pattern {
    height: 100%;
    margin-left: 10px;

    opacity: 0.35;
    background-repeat: repeat-y; // safari fix
    background-repeat-y: repeat;
    background-size: 50%;
    background-position: left;

    +desktop(){
      opacity: 0.6;
    }

    +above('xxl') {
      margin-left: 30px;
      background-size: 100%;
    }
  }

  & .odf-layout__background-blason {
    position: absolute;
    right: 0;
    top: 148px;

    transform-origin: right top;
    transform: scale((247 / 539));

    +above('m') {
      transform: scale((420 / 539));
    }

    +above('l') {
      top: 50%;
      right: 10px;
      transform: scale(0.5) translate(0, -50%);
    }

    +above('xl') {
      top: 50%;
      right: 10px;
      transform: scale(0.65) translate(0, -50%);
    }

    +above('xxl') {
      right: 90px;
      transform: translate(0, -50%);
    }
  }
}

.odf-layout__content {
  position: relative;
  z-index: 1;
  height: 100%;
  overflow: hidden;
  text-align: left;
}

.odf-layout__head {
  z-index: 2;
  +desktop() {
    position: absolute;
    top:  0;
    left: 0;
  }
}

.odf-layout__title {
  @extend $typo-landing-main-title;

  max-width: 335px;
  margin: 0 auto;

  color: $cl-white;
  text-transform: uppercase;
  text-align: center;

  +desktop() {
    max-width: 436px;

    text-align: left;
  }
}

.odf-layout__custom-content { height: 100%; }

.odf-layout__footer {
  display: none;
  position: absolute;
  z-index: 3;
  bottom:  0;
  left: 0;

  +desktop() {
    display: inline-block;
  }
}
</style>
